import { render, staticRenderFns } from "./BaseCointrIcon.vue?vue&type=template&id=f82e8ce8&scoped=true"
import script from "./BaseCointrIcon.vue?vue&type=script&lang=js"
export * from "./BaseCointrIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82e8ce8",
  null
  
)

export default component.exports